import { render, staticRenderFns } from "./profileView.vue?vue&type=template&id=1b8fb10d&scoped=true"
import script from "./profileView.vue?vue&type=script&lang=js"
export * from "./profileView.vue?vue&type=script&lang=js"
import style0 from "./profileView.vue?vue&type=style&index=0&id=1b8fb10d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8fb10d",
  null
  
)

export default component.exports